import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FaSearch, FaEdit, FaTrash, FaPlus } from 'react-icons/fa';
import { Modal, Button, Form } from 'react-bootstrap';

function NotesList() {
    const [notes, setNotes] = useState([]);
    const [categories, setCategories] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(100);

    // Modal state
    const [showModal, setShowModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [noteId, setNoteId] = useState(null);

    const [categoryId, setCategoryId] = useState('');
    const [noteText, setNoteText] = useState('');

    const fetchNotes = async () => {
        const token = localStorage.getItem('authToken');
        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/getnotes`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            if (!res.ok) throw new Error('Failed to fetch notes');
            const data = await res.json();
            setNotes(data.notes || []);
        } catch (error) {
            console.error(error);
        }
    };

    const fetchCategories = async () => {
        const token = localStorage.getItem('authToken');
        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/getcategories`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            if (!res.ok) throw new Error('Failed to fetch categories');
            const data = await res.json();
            setCategories(data.data || []);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchNotes();
        fetchCategories();
    }, []);

    const filteredNotes = notes.filter(note =>
        note && Object.values(note).some(value =>
            String(value).toLowerCase().includes(searchTerm.toLowerCase())
        )
    );

    // Pagination
    const indexOfLast = currentPage * itemsPerPage;
    const indexOfFirst = indexOfLast - itemsPerPage;
    const currentNotes = filteredNotes.slice(indexOfFirst, indexOfLast);
    const totalPages = Math.ceil(filteredNotes.length / itemsPerPage);

    const handlePageChange = (page) => setCurrentPage(page);

    const resetForm = () => {
        setCategoryId('');
        setNoteText('');
        setNoteId(null);
        setIsEditing(false);
    };

    const handleAddOrEditNote = async () => {
        const token = localStorage.getItem('authToken');
            const noteData = {
        category_id: Number(categoryId),
        note_text: noteText.trim()
    };

        const method = isEditing ? 'PUT' : 'POST';
        const url = isEditing
            ? `${process.env.REACT_APP_API_URL}/updatenotes/${noteId}`
            : `${process.env.REACT_APP_API_URL}/addnote`;

        try {
            const res = await fetch(url, {
                method,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(noteData),
            });
            if (!res.ok) throw new Error('Failed to add/update note');
            await fetchNotes();
            setShowModal(false);
            resetForm();
        } catch (error) {
            console.error(error);
        }
    };

    const handleEditClick = (note) => {
        setNoteId(note.notes_id);
        setCategoryId(note.category_id);
        setNoteText(note.note_text);
        setIsEditing(true);
        setShowModal(true);
    };

    const handleDeleteClick = (id) => {
        setNoteId(id);
        setShowDeleteModal(true);
    };

    const handleDeleteNote = async () => {
        const token = localStorage.getItem('authToken');
        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/deletenotes/${noteId}`, {
                method: 'DELETE',
                headers: { Authorization: `Bearer ${token}` },
            });
            if (!res.ok) throw new Error('Failed to delete note');
            await fetchNotes();
            setShowDeleteModal(false);
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <div className="container" style={{ marginTop: '80px' }}>
            <h2 className="text-primary">Notes List</h2>

            <div className="d-flex justify-content-between align-items-center mb-4">
                <div className="input-group me-3" style={{ maxWidth: '300px' }}>
                    <span className="input-group-text bg-primary text-white">
                        <FaSearch />
                    </span>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Search notes..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>
                <button className="btn btn-success" onClick={() => setShowModal(true)}>
                    <FaPlus /> Add Note
                </button>
            </div>

            <table className="table table-bordered table-striped">
                <thead className="table-primary">
                    <tr>
                        <th>ID</th>
                        <th>Category</th>
                        <th>Note</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {currentNotes.map(note => (
                        <tr key={note.notes_id}>
                            <td>{note.notes_id}</td>
                            <td>
    {categories.find(
        cat => Number(cat.category_id) === Number(note.category_id)
    )?.category || 'Unknown'}
</td>
                            <td>{note.note_text}</td>
                            <td>
                                <button
                                    className="btn btn-sm btn-outline-success me-2"
                                    onClick={() => handleEditClick(note)}
                                >
                                    <FaEdit /> Edit
                                </button>
                                <button
                                    className="btn btn-sm btn-outline-danger"
                                    onClick={() => handleDeleteClick(note.notes_id)}
                                >
                                    <FaTrash /> Delete
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {/* Pagination */}
            <nav>
                <ul className="pagination justify-content-center">
                    {[...Array(totalPages)].map((_, idx) => (
                        <li key={idx} className={`page-item ${currentPage === idx + 1 ? 'active' : ''}`}>
                            <button className="page-link" onClick={() => handlePageChange(idx + 1)}>
                                {idx + 1}
                            </button>
                        </li>
                    ))}
                </ul>
            </nav>

            {/* Modal */}
            <Modal show={showModal} onHide={() => { resetForm(); setShowModal(false); }}>
                <Modal.Header closeButton>
                    <Modal.Title>{isEditing ? 'Edit Note' : 'Add Note'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Category</Form.Label>
<Form.Select
    value={categoryId}
    onChange={(e) => setCategoryId(e.target.value)}
>
    <option value="">Select Category</option>

    {categories.map((cat) => (
        <option
            key={cat.category_id}
            value={cat.category_id}
        >
            {cat.category}
        </option>
    ))}
</Form.Select>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Note</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={4}
                                value={noteText}
                                onChange={e => setNoteText(e.target.value)}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => { resetForm(); setShowModal(false); }}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={handleAddOrEditNote}>
                        {isEditing ? 'Update' : 'Add'}
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Delete Confirmation Modal */}
            <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Deletion</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure you want to delete this note?</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
                        Cancel
                    </Button>
                    <Button variant="danger" onClick={handleDeleteNote}>
                        Delete
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default NotesList;
